'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BillingApi = function (_BaseApi) {
  (0, _inherits3.default)(BillingApi, _BaseApi);
  function BillingApi() {
    (0, _classCallCheck3.default)(this, BillingApi);
    var _this = (0, _possibleConstructorReturn3.default)(this, (BillingApi.__proto__ || Object.getPrototypeOf(BillingApi)).call(this, _frontendUtils.endpoints.billingBaseUrl));
    _this._userGuid = undefined;
    return _this;
  }
  (0, _createClass3.default)(BillingApi, [{
    key: 'get',
    value: function get() {
      var userGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._userGuid;
      if (!ValidationUtils.isGuid(userGuid)) {
        return Promise.reject(new _ParameterError2.default('userGuid', userGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'user/' + userGuid + '/subscription'
      });
    }
  }, {
    key: 'plans',
    value: function plans() {
      return this.makeRequest({
        method: 'GET',
        url: 'plans'
      });
    }
  }, {
    key: 'subscriptionPreview',
    value: function subscriptionPreview() {
      var userGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._userGuid;
      var planCode = arguments[1];
      if (!ValidationUtils.isGuid(userGuid)) {
        return Promise.reject(new _ParameterError2.default('userGuid', userGuid, 'guid string.'));
      }
      if (!ValidationUtils.isString(planCode)) {
        return Promise.reject(new _ParameterError2.default('planCode', planCode, 'string.'));
      }
      return this.makeRequest({
        method: 'GET',
        url: 'user/' + userGuid + '/subscriptionpreview',
        queryParameters: {
          planCode: planCode
        }
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var userGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._userGuid;
      var planCode = arguments[1];
      if (!ValidationUtils.isGuid(userGuid)) {
        return Promise.reject(new _ParameterError2.default('userGuid', userGuid, 'guid string.'));
      }
      if (!ValidationUtils.isString(planCode)) {
        return Promise.reject(new _ParameterError2.default('planCode', planCode, 'string.'));
      }
      return this.makeRequest({
        method: 'PATCH',
        url: 'user/' + userGuid + '/subscription',
        queryParameters: {
          planCode: planCode
        }
      });
    }

    /**
    make a subscription with a recurlyToken
    **/
  }, {
    key: 'subscribe',
    value: function subscribe() {
      var userGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._userGuid;
      var planCode = arguments[1];
      var recurlyToken = arguments[2];
      var couponCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var currency = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'USD';
      var account = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      if (!ValidationUtils.isGuid(userGuid)) {
        return Promise.reject(new _ParameterError2.default('userGuid', userGuid, 'guid string.'));
      }
      if (!ValidationUtils.isString(planCode)) {
        return Promise.reject(new _ParameterError2.default('planCode', planCode, 'string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'user/' + userGuid + '/subscription',
        body: {
          account: (0, _extends3.default)({}, account, {
            recurlyToken: recurlyToken,
            accountCode: userGuid
          }),
          planCode: planCode,
          couponCode: couponCode,
          currency: currency
        }
      });
    }

    /**
     * Move user to trial plan.
     */
  }, {
    key: 'moveToTrial',
    value: function moveToTrial() {
      var userGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._userGuid;
      if (!ValidationUtils.isGuid(userGuid)) {
        return Promise.reject(new _ParameterError2.default('userGuid', userGuid, 'guid string.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'admin/user/' + userGuid + '/trial/new'
      });
    }

    /**
     * Returns the current value of the user guid key.
     * @return {String}
     */
  }, {
    key: 'userGuid',
    get: function get() {
      return this._userGuid;
    }

    /**
     * Sets a new value of the user guid key.
     * @param  {String} val value to be set as current user guid string.
     */,

    set: function set(val) {
      this._userGuid = val;
    }
  }]);
  return BillingApi;
}(_BaseApi3.default);
exports.default = BillingApi;